import type { FC } from 'react';

import { Confirm } from '@coop/components';
import { useCallback } from 'react';

import useModal from '../../../hooks/useModal';
import { useAppDispatch, useAppSelector } from '../../../hooks/useThunkDispatch';
import { useTimeExpirationWithAsyncEnsure } from '../../../hooks/useTimeExpiration';
import { cartSelectors } from '../../../selectors/cartSelectors';
import { TimeslotModalType } from '../../../store/structureDefinitions/modalState';
import { cartThunks } from '../../../thunks/cartThunks';

interface TimeslotMaxOrderTimePassedDialogProps {
    handleConfirm?: () => void;
}

const TimeslotMaxOrderTimePassedDialog: FC<
    React.PropsWithChildren<TimeslotMaxOrderTimePassedDialogProps>
> = (props) => {
    const dispatch = useAppDispatch();

    const currentTimeslot = useAppSelector(cartSelectors.selectedTimeslot);
    const maxOrderTime = currentTimeslot?.maxOrderTime;

    const {
        isOpen: showDialog,
        open: openDialog,
        close: closeDialog,
    } = useModal(TimeslotModalType.TiemslotMaxOrderTimePassed);

    const nowMs = new Date().valueOf();
    const milisecondsToShowNotice = maxOrderTime ? maxOrderTime - nowMs : null;

    const onExpireCallback = useCallback(() => {
        openDialog();
    }, [openDialog]);

    const asyncEnsureCall = useCallback(() => dispatch(cartThunks.getCartSilent()), [dispatch]);

    useTimeExpirationWithAsyncEnsure(
        !!maxOrderTime && !showDialog ? milisecondsToShowNotice : null,
        asyncEnsureCall,
        onExpireCallback,
    );

    return (
        <Confirm
            show={showDialog}
            heading="Din reserverade tid är inte längre tillgänglig"
            message="Varorna finns fortfarande kvar i din varukorg."
            confirmButtonText="Reservera ny tid"
            onConfirm={() => {
                closeDialog();
                if (props.handleConfirm) {
                    props.handleConfirm();
                }
            }}
            close={closeDialog}
        />
    );
};

export default TimeslotMaxOrderTimePassedDialog;
